// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

// reviews images
import review1 from './img/review1.jpg';
import review2 from './img/review2.jpg';
// team images
import hostess from './img/hostess.jpg';
//import chef from './img/chef.jpg';
//import barman from './img/barman.jpg';
//import waiter from './img/waiter.jpg';
// gallery images
import gallery1 from './img/gallery/gallery1.jpg';
import gallery2 from './img/gallery/gallery2.jpg';
import gallery3 from './img/gallery/gallery3.jpg';
import gallery4 from './img/gallery/gallery4.jpg';
import gallery5 from './img/gallery/gallery5.jpg';
import gallery6 from './img/gallery/gallery6.jpg';
import gallery7 from './img/gallery/gallery7.jpg';
import gallery8 from './img/gallery/gallery8.jpg';
import gallery9 from './img/gallery/gallery9.jpg';
import gallery10 from './img/gallery/gallery10.jpg';
import gallery11 from './img/gallery/gallery11.jpg';
import gallery12 from './img/gallery/gallery12.jpg';


export const reviewsList = [
   {
      img: review1,
      name: 'Kiera M.',
      stars: 5,
      text: 'Wowwww! Staying at this place was just what I needed for a getaway. My friend and I stayed here and it was everything we hoped for. The bedding was super comfy and welcoming. The decor was very nice. And there’s a fire place and wood available which is nice if you come during the cold months. In the mornings we would drink coffee and look out at the lake and it was the best way to start the day. I wish I could move in! Kristy, the hostess, was incredibly friendly as well. Easy to talk to and very helpful! 5 stars!!! You won’t regret staying here.'
   },
   {
      img: review2,
      name: 'Joe P.',
      stars: 5,
      text: 'This cabin is so perfect, clean and nicely decorated. I can’t wait to book it again this summer! The lake views at this cabin are spectacular and the extra attention to detail in the cabin is so fun. Also the bed linens are luxurious. We plan to bring our whole Family back to enjoy this hidden gem...'
   }
];


export const teamMembers = [
   {
      img: hostess,
      role: 'Hostess',
      name: 'Kristy',
      text: 'I have a passion for working with people, design, and good times.  Vacation rental allows me to do all of that!  For 20+ years, I have been a realtor, builder, land developer, property manager, and hostess.  My team and I are back in the Gull Lake Chain/Whitefish Lake Chain area again and having a blast.  Let`s get acquainted and let the fun begin!',
      cite: '...Kristy is the epitome of a hostess, she made our week better than we could have hoped! - Kate M.'
   },
/*   {
      img: barman,
      role: 'Barman',
      name: 'Bruno Smith',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.',
      cite: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
   },
   {
      img: waiter,
      role: 'Waiter',
      name: 'Jessica Smith',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.',
      cite: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
   }, */
];


export const faqList = [
   {
      question: 'Where is Kamp Christy located?',
      answer: 'Kamp Christy is located on Upper Gull Lake in Lake Shore, Minnesota, part of the Gull Lake Chain of Lakes. It is approximately 2 hours north of Minneapolis, just minutes from Brainerd.'
   },
   {
      question: 'How many guests does Kamp Christy sleep?',
      answer: 'The cabin accommodates 10+ guests with a great room, indoor kitchen and dining table for 10, plus outdoor deck seating for 10 more.'
   },
   {
      question: 'Is there a private beach at Kamp Christy?',
      answer: 'Yes, Kamp Christy has a beautiful private swimming area on Upper Gull Lake, perfect for lily pads, floaties, or paddle boarding. Two kayaks are also included for guest use.'
   },
   {
      question: 'Can I bring my own boat to Kamp Christy?',
      answer: 'Yes, there are 2 docks available at Kamp Christy. You can bring your own boat or rent one on the lake.'
   },
   {
      question: 'What is the rental season for Kamp Christy?',
      answer: 'The rental season runs from mid-May through October 1. However, guests are welcome to inquire about availability outside of these dates.'
   },
   {
      question: 'What amenities does Kamp Christy offer?',
      answer: 'Kamp Christy offers a private beach, 2 boat docks, 2 kayaks, a fire pit, outdoor deck, outdoor grill, indoor fireplace with firewood, yard games, fully furnished kitchen, and dining for 10 inside and out. The cabin has been recently refreshed with modern comforts while keeping its classic charm.'
   },
   {
      question: 'How do I book Kamp Christy?',
      answer: 'You can book Kamp Christy through <a href="https://www.vrbo.com/2995894?unitId=3567938" target="_blank" rel="noopener noreferrer">VRBO</a> or <a href="https://airbnb.com/h/kampchristy" target="_blank" rel="noopener noreferrer">Airbnb</a>, or contact the host directly through the <a href="/contact">contact form</a>.'
   }
];


export const galleryImgs = [
   {
      src: gallery1,
      alt: 'Kamp Christy cabin exterior with lake view on Upper Gull Lake'
   },
   {
      src: gallery2,
      alt: 'Private beach and dock on Upper Gull Lake at Kamp Christy'
   },
   {
      src: gallery3,
      alt: 'Cozy cabin interior and great room at Kamp Christy'
   },
   {
      src: gallery4,
      alt: 'Lakefront deck with seating at Kamp Christy cabin'
   },
   {
      src: gallery5,
      alt: 'Sunset over Upper Gull Lake from Kamp Christy'
   },
   {
      src: gallery6,
      alt: 'Cabin bedroom with comfortable bedding at Kamp Christy'
   },
   {
      src: gallery7,
      alt: 'Fire pit area at Kamp Christy cabin on Gull Lake'
   },
   {
      src: gallery8,
      alt: 'Kitchen and dining area inside Kamp Christy cabin'
   },
   {
      src: gallery9,
      alt: 'Kayaks and water activities at Kamp Christy on Gull Lake'
   },
   {
      src: gallery10,
      alt: 'Morning lake view from Kamp Christy cabin deck'
   },
   {
      src: gallery11,
      alt: 'Outdoor grill and entertaining space at Kamp Christy'
   },
   {
      src: gallery12,
      alt: 'Gull Lake Chain waterfront at Kamp Christy Minnesota'
   }
];